import React, { useEffect } from 'react'
import Modal from '../../../../common/modal'
import { Box, Button, Divider, Typography } from '@mui/material'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import * as mdt from '../../../../common/modaltypes'
import { focusElemnt } from '../../../../common/helper'

const ConfirmModal = ({ updateModal }) => {
  const modalStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
  const modalHeaderStyle = {
    display: 'none',
  }
  useEffect(() => {
    focusElemnt('okayBtn')
  }, [])
  return (
    <Modal
      headTxt={'Confirm'}
      // width={'35%'}
      width={'300px'}
      height={'176px'}
      updateModal={updateModal}
      closeId={'closeButton'}
      modalClass={'booking-popup'}
      bgColor={'#AAE8AA'}
      modalStyle={modalStyle}
      modalHeaderStyle={modalHeaderStyle}
    >
      <Box sx={{ padding: '10px 15px' }}>
        <Typography
          variant="h6"
          sx={{ fontWeight: '700', textAlign: 'center', color: '#008000', fontSize: '16px', paddingTop: '5px', paddingBottom: '25px' }}
        >
          New Auto Delivery Config <br />
          Saved Successfully!
        </Typography>

        <Box className="disabled-wrapper" sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            id={'okayBtn'}
            variant="contained"
            style={{ ...sx.fullHeight, ...sx.novp, height: '40px', width: '200px', background: '#008000' }}
            className="btn btn-primary"
            onClick={() => {
              updateModal(false, mdt.autoDeliveryConfModal)
              focusElemnt('Select_Consignment_Type')
            }}
          >
            Ok
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConfirmModal
